import { SyntheticEvent, useContext, useEffect, useState } from "react";

import { css } from "@emotion/react";
import MuiSnackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";

import Alert from "components/DesignComponents/Alert";
import AlertContext from "context/alert/alertContext";

import { processAlertData, processSnackPack } from "./functions";
import TransitionLeft from "./TransitionLeft";
import { SnackbarData } from "./types";

const Snackbar = () => {
    const {
        status,
        title,
        description,
        primaryBtn,
        secondaryBtn,
        hasCloseBtn,
        hasAutoHide,
        removeAlert
    } = useContext(AlertContext);

    const [isOpen, setIsOpen] = useState(false);
    const [snackPack, setSnackPack] = useState<SnackbarData[]>([]);

    const [alertData, setAlertData] = useState<SnackbarData>({
        status: null,
        title: null,
        description: null,
        primaryBtn: null,
        secondaryBtn: null
    });

    const {
        status: alertStatus,
        title: alertTitle,
        description: alertDescription,
        primaryBtn: alertPrimaryBtn,
        secondaryBtn: alertSecondaryBtn
    } = alertData;

    useEffect(() => {
        processSnackPack({
            status,
            snackPack,
            title,
            description,
            primaryBtn,
            secondaryBtn,
            setSnackPack,
            setIsOpen
        });
        // eslint-disable-next-line
    }, [status, title, description]);

    useEffect(() => {
        processAlertData(
            snackPack,
            alertStatus,
            isOpen,
            setAlertData,
            setIsOpen
        );
        // eslint-disable-next-line
    }, [snackPack, alertData, isOpen]);

    const handleClose = (
        _e: SyntheticEvent<any> | Event,
        reason?: SnackbarCloseReason
    ) => {
        const hasReasonNotClose = hasCloseBtn
            ? reason === "clickaway"
            : reason === "clickaway" || reason === "escapeKeyDown";

        if (hasReasonNotClose) return;

        removeAlert();
    };

    const handleExited = () =>
        setAlertData({
            status: null,
            title: null,
            description: null,
            primaryBtn: null,
            secondaryBtn: null
        });

    return alertStatus && alertTitle ? (
        <MuiSnackbar
            open={isOpen}
            disableWindowBlurListener
            autoHideDuration={hasAutoHide ? 6000 : null}
            onClose={handleClose}
            slotProps={{
                transition: {
                    onExited: handleExited
                }
            }}
            slots={{
                transition: TransitionLeft
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
            <div
                css={css({
                    width: "448px"
                })}
            >
                <Alert
                    status={alertStatus}
                    title={alertTitle}
                    description={alertDescription || undefined}
                    primaryBtn={alertPrimaryBtn || undefined}
                    secondaryBtn={alertSecondaryBtn || undefined}
                    close={hasCloseBtn ? handleClose : undefined}
                />
            </div>
        </MuiSnackbar>
    ) : null;
};

export default Snackbar;
